import React, { useRef } from "react";
import { Footer, SecondaryButton } from "@ucl/library";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import "./FinancialProductCard.scss";
import classNames from "classnames";

export interface FinancialProduct {
  id: string;
  title: string;
  description: string;
  features: string[];
  isSelected?: boolean;
  customerSegment: string;
  initialDeposit?: number;
}

export interface FinancialProductCardProps {
  product: FinancialProduct;
  className?: string;
  isSelected?: boolean;
}

export const FinancialProductCard: React.FC<FinancialProductCardProps> = ({
  product,
  className = "",
  isSelected = false,
}) => {
  const refToOuterDiv = useRef<HTMLDivElement>(null);

  const clickOuterDiv = () => {
    refToOuterDiv.current?.click();
  };

  return (
    <div className={`financial-product-card ${className}`} ref={refToOuterDiv}>
      <div className="financial-product-card__content-container">
        <div className="financial-product-card__content">
          <p className="financial-product-card__description">{product.description}</p>
          <ul className="financial-product-card__features">
            {product.features?.map((feature, index) => (
              <li key={index} className="financial-product-card__feature">
                <FontAwesomeIcon icon={faCheck} className="financial-product-card__feature-icon" />
                {feature}
              </li>
            ))}
          </ul>
        </div>
        <Footer className="financial-product-card__footer">
          <SecondaryButton
            className={classNames("financial-product-card__select-button", isSelected && "selected")}
            text={isSelected ? "Selected" : "Select"}
            onClick={clickOuterDiv}
            iconProps={{
              icon: faCheck
            }}
            iconPosition="right"
          />
        </Footer>
      </div>
    </div>
  );
};

export default FinancialProductCard;
